import React from 'react';
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withStyles} from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction/BottomNavigationAction";
import {Context} from "./ContextProvider";
import IconButton from "@material-ui/core/IconButton/IconButton";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";
import {grToPln, meterToKm, secondsToTime, secToMin, toExponential} from "./Helpers";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableRow from "@material-ui/core/TableRow/TableRow";
import * as Consts from "./Consts";
import * as Logger from "./Logger";

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.secondary.main,
        color: "black",
        height: Consts.mobileFooterHeigth,
        width: "100%",
        position: "fixed",
        bottom: 0,
        paddingTop:  theme.spacing.unit * 2,
    },

});


function ItineraryDetailMobile(props) {
    const {classes} = props;
    const {state, dispatch} = React.useContext(Context);

    const { itineraries, selectedItineraryId} = state;
    let {selectedLegIndex} = state;

    if (!selectedLegIndex) {
        selectedLegIndex = 0;
    }

    function findIti(iti) {
        return iti.id === selectedItineraryId
    }

    Logger.log("Selected leg is: " + selectedLegIndex);
    const selectedLegIndexNo = parseInt(selectedLegIndex);

    Logger.log("selected");
    Logger.log(itineraries.plan.itineraries.find(findIti).legs.length);
    const leg = itineraries.plan.itineraries.find(findIti).legs[selectedLegIndex];

    return <div  className={classes.root}>
        <IconButton disabled={selectedLegIndex == 0}
                    onClick={() => dispatch({type: "itiLegDetails", payload: selectedLegIndex - 1})}>
            <ArrowLeft/>
        </IconButton>
        {secondsToTime(leg.startTime)} {leg.mode} {secondsToTime(leg.endTime)} {secToMin(leg.duration)} m {meterToKm(leg.distance)} km


        <IconButton style={{position: "fixed", right: "0px"}}
                    disabled={selectedLegIndex >= itineraries.plan.itineraries.find(findIti).legs.length - 1}
                    onClick={() => dispatch({type: "itiLegDetails", payload: selectedLegIndex + 1})}>
            <ArrowRight/>
        </IconButton>
    </div>
}


export default withWidth()(withStyles(styles)(ItineraryDetailMobile))

